import { css } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { spacingPx } from '@moonpig/launchpad-theme'

export const getSharedButtonStyles = (isOpen = true) => css`
  ${s({ p: 3, top: 0, color: 'colorInteractionIcon' })}
  ${({ theme }) =>
    s({
      height: !isOpen
        ? { xs: '40px', md: spacingPx(12)({ theme }) }
        : spacingPx(12)({ theme }),
      width: !isOpen
        ? { xs: '40px', md: spacingPx(12)({ theme }) }
        : spacingPx(12)({ theme }),
    })};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: transparent;

  &:not(:disabled) {
    cursor: pointer;
  }

  &[disabled] {
    ${s({ color: 'colorInteractionIcon' })}
    background-color: transparent;
  }
`
